import { connect } from 'react-redux';
import { getGroupsStream } from '../../redux/selectors';
const mapStateToProps = (state)=>getGroupsStream(state);
export default connect(mapStateToProps);

//# sourceMappingURL=GroupsList.container.js.map